/* eslint-disable no-nested-ternary */
import { Button, Card, Dropdown, Menu, Popover, Select, Tooltip } from 'antd'
import React, { FC, useEffect, useState, useTransition } from 'react'
import { TSelectType } from 'types'
import { queryClient } from 'lib/react-query'
import { baseTime } from 'lib'
import { ItemType } from 'antd/lib/menu/hooks/useItems'
import { TMuteNotification } from '../types'
import { useLeadMuteMutation } from '../api'

const getTimeStampFromValue = (val: TMuteNotification) => {
 switch (val) {
  case 'one_hour':
   return baseTime().add(1, 'hour').utc().format()
  case 'six_hours':
   return baseTime().add(6, 'hour').utc().format()
  case 'twelve_hours':
   return baseTime().add(12, 'hour').utc().format()
  case 'today':
   return baseTime().endOf('day').utc().format()
  case 'tomorrow':
   return baseTime().add(1, 'day').endOf('day').utc().format()
  case 'one_week':
   return baseTime().add(1, 'week').endOf('day').utc().format()
  case 'one_month':
   return baseTime().add(1, 'month').endOf('day').utc().format()
  case 'three_months':
   return baseTime().add(3, 'month').endOf('day').utc().format()
  case 'six_months':
   return baseTime().add(6, 'month').endOf('day').utc().format()
  case 'one_year':
   return baseTime().add(1, 'year').endOf('day').utc().format()
  default:
   return null
 }
}

const muteNotificationData = (isMuted: boolean): ItemType[] => {
 const datas: ItemType[] = [
  {
   label: '1 hr',
   key: 'one_hour',
  },
  {
   label: '6 hrs',
   key: 'six_hours',
  },
  {
   label: '12 hrs',
   key: 'twelve_hours',
  },
  {
   label: 'Today',
   key: 'today',
  },
  {
   label: 'Tomorrow',
   key: 'tomorrow',
  },
  {
   label: '1 Week',
   key: 'one_week',
  },
  {
   label: '1 Month',
   key: 'one_month',
  },
  {
   label: '3 Months',
   key: 'three_months',
  },
  {
   label: '6 Months',
   key: 'six_months',
  },
  {
   label: '1 Year',
   key: 'one_year',
  },
  {
   label: 'Always',
   key: 'always',
  },
  ...(isMuted
   ? ([
      {
       label: 'Unmute',
       key: 'un_mute',
      },
     ] as any)
   : []),
 ]

 return datas
}

const MuteNotification: FC<{
 isLoading?: boolean
 refetch?: () => void
 mutePeriod?: string
 name?: string
 initMuted?: boolean
 leadId?: any
}> = ({
 leadId,
 initMuted,
 name,
 mutePeriod,
 refetch,
 isLoading: leadLoading,
}) => {
 const [timePeriod, setTimePeried] = useState<string | null>(mutePeriod ?? null)
 const [isPending, startTransition] = useTransition()
 const [muted, setMuted] = useState(initMuted ?? false)
 const [mutation, { isLoading }] = useLeadMuteMutation()
 const [show, setShow] = React.useState<boolean>(false)
 const [value, setValue] = React.useState<TMuteNotification | null>(null)

 useEffect(() => {
  setMuted(initMuted ?? false)
  setTimePeried(mutePeriod ?? null)
 }, [initMuted, mutePeriod])

 return (
  <Dropdown
   visible={show}
   onVisibleChange={(v) => setShow(v)}
   trigger={['click']}
   overlay={
    <Menu
     onClick={async ({ key }) => {
      const val = key as TMuteNotification
      const timeData = getTimeStampFromValue(val)

      await mutation({
       duration: val,
       lead_id: leadId,
       mute_period: timeData,
      }).unwrap()
      if (val === 'un_mute') {
       setMuted(false)
      } else {
       setMuted(true)
      }
      setValue(val)
      setTimePeried(timeData)
      setShow(false)
      queryClient.invalidateQueries('get-leads-web')
      refetch?.()
      setShow(false)
     }}
     items={muteNotificationData(muted)}
    />
   }
  >
   <Tooltip overlay={`Mute the Lead Engagement Alerts for ${name}`}>
    <Button
     loading={isLoading}
     icon={
      <i className={`fal me-1 ${muted ? 'fa-bell-slash' : 'fa-bell-on'}`} />
     }
     size="small"
    >
     {!muted
      ? 'Mute Notifications'
      : timePeriod
      ? `Muted until ${baseTime(timePeriod).calendar('', {
         sameElse: 'lll',
        })}`
      : 'Muted Always'}
    </Button>
   </Tooltip>
  </Dropdown>
 )

 //  return (
 //   <Popover
 //    visible={show}
 //    onVisibleChange={(v) => setShow(v)}
 //    overlayStyle={{ width: '200px' }}
 //    placement="bottom"
 //    trigger="click"
 //    content={
 //     <div>
 //      <Select
 //       loading={isLoading}
 //       value={value}
 //       placeholder="Select Duration"
 //       dropdownStyle={{ zIndex: 99999999999 }}
 //       onChange={async (v) => {
 // setValue(v)
 // await mutation({ duration: v, lead_id: leadId }).unwrap()
 // if (v === 'un_mute') {
 //  setMuted(false)
 // } else {
 //  setMuted(true)
 // }
 // queryClient.invalidateQueries('get-leads-web')
 // refetch?.()
 // setShow(false)
 //       }}
 //       options={muteNotificationData(muted)}
 //       className="w-100"
 //      />
 //     </div>
 //    }
 //   >
 // <Tooltip overlay={`Mute the Lead Engagement Alerts for ${name}`}>
 //  <Button
 //   icon={
 //    <i className={`fal me-1 ${muted ? 'fa-bell-slash' : 'fa-bell-on'}`} />
 //   }
 //   size="small"
 //  >
 //   {!muted
 //    ? 'Mute Notifications'
 //    : mutePeriod
 //    ? `Mute until ${baseTime(mutePeriod).calendar()}`
 //    : 'Mute Always'}
 //  </Button>
 // </Tooltip>
 //   </Popover>
 //  )
}

export default MuteNotification
